module.exports = __webpack_public_path__ + "static/media/tiffinfinds-vendor.46edd92a.png";